module.exports = __webpack_public_path__ + "static/media/selena-gomez.48098655.jpg";